import { render, staticRenderFns } from "./PartnerIncomeReport.vue?vue&type=template&id=180827b4&"
import script from "./PartnerIncomeReport.vue?vue&type=script&lang=js&"
export * from "./PartnerIncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./PartnerIncomeReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports